import selectColorMp3 from "@/components/common/selectColorMp3";
import { SITE_DOMAIN } from "@/constant";

export const Mp3InitialData = {
  payload: {
    mp3: "",
    mp3_path: "",
    mp3_name: "",
    mp3_size: 0,
    title: "",
    info: "",
    name: "",
    logo: "",
    logo_name: "",
    logo_type: "",
    logo_path: "",
    welcome_screen: "",
    welcome_path: "",
    website: "",
    design_colors_primary: selectColorMp3[0].color,
    design_colors_button: selectColorMp3[0].buttonColor,
    button: "",
    button_url: "",
  },
  showButton: false,
};

export const AddButtonMp3Data = [
  {
    value: "Buy now",
    icon: "",
  },
  {
    value: "Learn more",
    icon: "",
  },
  {
    value: "Visit us online",
    icon: "",
  },
  {
    value: "View full album",
    icon: "",
  },
  {
    value: "Custom",
    icon: "/common/edit-icon.svg",
  },
];
